/**
 * Takes unknown and value and attempts to
 * coerce it into an instance of an Error if
 * not already one. When the value is null or
 * undefined an 'Unknown error' is returned.
 *
 * @internal
 */
export function ensureError(error: unknown): Error
export function ensureError(error: unknown, defaultMessage: string): Error
export function ensureError(error: unknown, defaultMessage?: string): Error {
    let err = new Error(defaultMessage ?? 'Unknown error')
    if (error instanceof Error) {
        err = error
    } else if (error !== undefined && error !== null) {
        try {
            err = new Error(String(error))
        } catch {}
    }
    return err
}
